import { TooltipProvider, TooltipContent, TooltipTrigger, TooltipRoot } from './tooltip-base.component';

interface TooltipProps {
  children: React.ReactNode;
  message: string;
  className?: string;
}

export function Tooltip({ children, message, className }: TooltipProps) {
  return (
    <TooltipProvider>
      <TooltipRoot>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className={className}>{message}</TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
}
